/* eslint-disable prefer-template, prefer-const */

import { withStyles } from '@material-ui/core/styles'
import cn from 'classnames'
import moment from 'moment'
import { useEffect, useState } from 'react'

const styles = theme => ({
  wrapper: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    padding: '18px 30px',
    backgroundColor: theme.status.timerBG,
    border: `1px solid ${theme.status.timerColor}`,
    borderRadius: theme.borders.borderRadius,
    '&$finished': {
      backgroundColor: theme.status.errorBG,
      borderColor: theme.colors.red,
      '& $time': {
        color: theme.colors.red,
      },
    },
  },
  time: {
    marginRight: '30px',
    fontSize: '36px',
    color: theme.status.timerColor,
  },
  message: {
    margin: 0,
    color: `var(--gameday-body-textColor, ${theme.body.textColor})`,
    fontSize: theme.typography.fontSizeSm,
  },
  finished: {},
})

function CountdownNotification({ classes, defaultMessage, errorMessage, startTimer, time, onTimeup, reset }) {
  const [futureTime, setFutureTime] = useState(moment().unix() + time)
  const [timer, setTimer] = useState(time)
  const [finished, setFinished] = useState(false)

  useEffect(() => {
    if (timer <= 0 || futureTime - moment().unix() <= 0) {
      setTimer(0)
      onTimeup()
      return setFinished(true)
    }

    const countDownInterval = setInterval(() => {
      if (startTimer) {
        setTimer(timer - 1)
      }
    }, 1000)

    return () => {
      if (countDownInterval) {
        clearInterval(countDownInterval)
      }
    }
  }, [timer, startTimer])

  useEffect(() => {
    setFutureTime(moment().unix() + (time - 1))
    setTimer(time - 1)
  }, [reset])

  function convertSeconds(ms) {
    const minutes = Math.floor(ms / 60)
    const seconds = ((ms % 60) / 1).toFixed(0)
    // biome-ignore lint/style/useTemplate: TODO
    return minutes + ':' + (seconds < 10 ? '0' : '') + seconds
  }

  return (
    <div className={cn(classes.wrapper, { [classes.finished]: finished })}>
      <time className={classes.time}>{convertSeconds(futureTime - moment().unix() || timer)}</time>
      <p className={classes.message}>{!finished ? defaultMessage : errorMessage}</p>
    </div>
  )
}

CountdownNotification.defaultProps = {
  defaultMessage: `Please complete your registration within 15 minutes.
    The countdown will start when you proceed to the next screen.`,
  errorMessage: 'Time is up!',
  reset: false,
  time: 900,
  onTimeup: () => {},
}

const CountdownComponent = withStyles(styles)(CountdownNotification)
CountdownComponent.displayName = 'CountdownNotification'
export default CountdownComponent
